import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Form, Image, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getToken } from '../utils/util';
import { login } from '../services/seguridad/auth-service';

function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [empresa, setEmpresa] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const checkToken = async () => {
      const token = getToken();
      if (token) {
        navigate("/main");
      }
    };
    checkToken();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const empresaClean = (empresa || '').trim();
    try {
      await login(empresaClean, username, password);
      navigate('/main');
    } catch (error) {
      setErrorMessage(error.message);
    }
  };

  return (
    <Container fluid className="d-flex justify-content-center align-items-center vh-100" style={{ background: "#F5F5F5" }}>
      <Helmet>
        <title>Ingresar | Alpha</title>
        <meta name="description" content="Ingreso a la plataforma Alpha — acceso a módulos de gestión empresarial." />
        <meta property="og:title" content="Ingresar | Alpha" />
        <meta property="og:description" content="Accede a Alpha para gestionar ventas, compras y almacén." />
      </Helmet>
      <Form className="text-center" onSubmit={handleSubmit}>
        <Image src="logo.webp" alt="Imagen" width="192" height="210" className="mb-1" />
        <h1 className="mb-3" hidden>Empresa</h1>
        <Form.Group controlId="empresa">
          <Form.Control
            type="text"
            className="form-control form-control-lg"
            pattern="[A-Za-z0-9]{1,12}"
            maxLength="12"
            required
            placeholder="Empresa"
            autoComplete="organization"
            value={empresa}
            onChange={(e) => setEmpresa(e.target.value)}
          />
        </Form.Group>
        <Form.Group controlId="username">
          <Form.Control
            type="text"
            className="form-control form-control-lg"
            pattern="[A-Za-z0-9]{1,30}" 
            maxLength="30"
            required
            autoFocus
            placeholder="Usuario"
            autoComplete="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </Form.Group>
        <Form.Group controlId="password">
          <Form.Control
            type="password"
            className="form-control form-control-lg"
            autoComplete="on"
            maxLength="30"
            required
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Group>
        <Form.Group className="d-grid gap-2">
          <Button variant="primary" type="submit" className="btn-lg">
            Ingresar
          </Button>
        </Form.Group>
        {errorMessage && <p className="text-danger">{errorMessage}</p>}
      </Form>
    </Container>
  );
}

export default Login;
